var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-tag-view"},[_c('div',{staticClass:"article-tag-group"},_vm._l((_vm.tags),function(item,index){return _c('van-tag',{key:index,staticClass:"article-tag",attrs:{"round":"","size":"medium","plain":""},on:{"click":function($event){return _vm.$emit('click',item)}}},[_vm._v(_vm._s(item))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }